import { ParticipantBehaviourStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const participantBehaviourStatusOptions = {
  [ParticipantBehaviourStatus.Active]: {
    label: 'Active',
    value: ParticipantBehaviourStatus.Active,
    raw: ParticipantBehaviourStatus.Active,
    color: 'green',
  },
  [ParticipantBehaviourStatus.Archived]: {
    label: 'Archived',
    value: ParticipantBehaviourStatus.Archived,
    raw: ParticipantBehaviourStatus.Archived,
    color: 'gray',
  },
};

interface Props extends ChakraV3.TagProps {
  status: ParticipantBehaviourStatus;
}

export const ParticipantBehaviourStatusTag = (props: Props) => {
  const { status, ...rest } = props;

  const option = participantBehaviourStatusOptions[status];

  return (
    <ChakraV3.Tag size='sm' colorPalette={option.color} {...rest}>
      {option.label}
    </ChakraV3.Tag>
  );
};
